import { render } from "./RegionShymkent.vue?vue&type=template&id=6b8ed6c6&ts=true"
import script from "./RegionShymkent.vue?vue&type=script&lang=ts"
export * from "./RegionShymkent.vue?vue&type=script&lang=ts"

import "./RegionShymkent.vue?vue&type=style&index=0&id=6b8ed6c6&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__